<template>
  <div>
    <BaseTitle :title="$t(edit ? 'content.class_level_edit' : 'content.class_level_create')" />
    <form @submit.prevent="submit">
      <v-card class="mb-8 pa-8">
        <form-group :name="$t('form.class_level_name')" :validator="$v.form.name">
          <template slot-scope="{ attrs }">
            <v-text-field
              v-model="form.name"
              v-bind="attrs"
              :disabled="form.used == true"
              :label="$t('form.class_level_name')"
              @input="$v.form.name.$touch()"
              @blur="$v.form.name.$touch()"
            />
          </template>
        </form-group>
      </v-card>
      <v-card class="mb-8 pa-4">
        <form-group :name="$t('form.parent_access_to_mobile_and_web')">
          <template slot-scope="{ attrs }">
            <div class="d-flex align-center justify-space-between">
              <div>{{ $t('form.parent_access_to_mobile_and_web') }}</div>
              <v-switch v-model="form.parentAccess" v-bind="attrs" @input="$v.form.parentAccess.$touch()" @blur="$v.form.parentAccess.$touch()" />
            </div>
          </template>
        </form-group>
      </v-card>
      <div class="d-flex justify-end align-center">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
        <v-btn color="primary" :loading="loading" class="btn-primary-custom" type="submit">{{ $t(edit ? 'save' : 'submit') }}</v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import onlyWord from '@/validators/onlyWord';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'ClassLevelForm',
  components: {
    BaseTitle
  },
  validations: {
    form: {
      name: { required, onlyWord },
      parentAccess: { required }
    }
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    })
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.form.schoolId = value.schoolId;
      }
    }
  },
  data: () => ({
    edit: false,
    loading: false,
    form: {
      name: '',
      parentAccess: false,
      schoolId: '',
      used: ''
    }
  }),
  methods: {
    getData() {
      this.$store
        .dispatch('ClassLevel/fetchDetail', this.$route.params.id)
        .then(res => Object.keys(this.form).forEach(form => (this.form[form] = res[form])));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return false;
      const payload = {
        ...(this.edit ? { id: this.$route.params.id } : null),
        ...this.form
      };
      this.loading = true;
      this.$store
        .dispatch(`ClassLevel/${this.edit ? 'update' : 'save'}`, payload)
        .then(() => this.$router.push({ name: this.edit ? 'ClassLevelUpdateSuccess' : 'ClassLevelSuccess' }))
        .finally(() => (this.loading = false));
    },
    backToList() {
      this.$router.push({ name: 'ClassLevelIndex' });
    }
  },
  created() {
    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    }
  }
};
</script>
